export default __webpack_public_path__ + "static/media/pdf-down-icon.9a6de2bd.svg";